import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '../base'
import { AppIcons } from '../AppIcons'
import { CardItem } from '../CardItem'

import { CryptoAddressWithdrawDTO } from '@/domain/wallet'
import { formatAddress } from '@/utils'

export interface WalletAddressItemProps extends CryptoAddressWithdrawDTO {
  onPress: (item: CryptoAddressWithdrawDTO) => void
  onPressDelete: () => void
  isLoading?: boolean
}

export const WalletAddressItem: React.FC<WalletAddressItemProps> = ({
  onPress,
  onPressDelete,
  isLoading = false,
  ...item
}) => {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <div className="animate-pulse">
        <div className="bg-gray-700 rounded-xl p-4 h-20"></div>
      </div>
    )
  }

  return (
    <CardItem.Root
      onPress={() => onPress(item)}
      style={{
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      className="hover:bg-gray-700 transition-colors"
    >
      <BaseView gap={8} flex={1}>
        <BaseText
          fontSize={16}
          fontWeight="600"
          color="white"
          numberOfLines={1}
        >
          {item.name || t('translation:unnamed')}
        </BaseText>
        <BaseText
          fontSize={14}
          color="gray.400"
          numberOfLines={1}
          style={{ fontFamily: 'monospace' }}
        >
          {formatAddress(item.address)}
        </BaseText>
      </BaseView>

      <button
        onClick={(e) => {
          e.stopPropagation()
          onPressDelete()
        }}
        className="ml-3 p-2 rounded-full bg-gray-600 hover:bg-gray-500 transition-colors"
        style={{ minWidth: '32px', minHeight: '32px' }}
      >
        <AppIcons name="close" size={16} color="#9CA3AF" />
      </button>
    </CardItem.Root>
  )
}
